const data = {
  wish: {
    id: 'title',
    label: 'Title',
    name: 'title',
    placeholder: 'Für die Zukunft wünsche ich mir ...'
  },
  location: {
    id: 'userResidence',
    label: 'Deine Stadt',
    name: 'userResidence',
    placeholder: 'Deine Stadt',
    labels: {
      giveConsentCopy: 'Consent Copy',
      giveConsentDetailsCta: 'Consent Details CTA',
      giveConsentCta: 'Consent CTA'
    }
  },
  age: {
    label: 'Dein Alter',
    cells: [
      {
        id: '0-20',
        name: 'userAgeGroup',
        label: '0-20',
        value: '0-20'
      },
      {
        id: '21-40',
        name: 'userAgeGroup',
        label: '21-40',
        value: '21-40'
      },
      {
        id: '41-60',
        name: 'userAgeGroup',
        label: '41-60',
        value: '41-60'
      },
      {
        id: '60+',
        name: 'userAgeGroup',
        label: '60+',
        value: '60+'
      }
    ]
  },
  gender: {
    label: 'Dein Geschlecht',
    cells: [
      {
        id: 'm',
        name: 'userGender',
        label: 'Männlich',
        value: 'm'
      },
      {
        id: 'f',
        name: 'userGender',
        label: 'Weiblich',
        value: 'f'
      },
      {
        id: 'd',
        name: 'userGender',
        label: 'Divers',
        value: 'd'
      }
    ]
  },
  actions: {
    prev: 'Zurück',
    next: 'Weiter',
    submit: 'Wunsch senden'
  }
};

export default data;
